import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-screen-width',
  templateUrl: './screen-width.component.html',
  styleUrls: ['./screen-width.component.scss']
})
export class ScreenWidthComponent implements OnInit {
  title:string = "Dimensions";
  toolTip:string = "The tooltip";
  selectedItem;

  fields = [
    {
      name:"contentWidth",
      title:"Main Content Width",
      type:"width",
      controlType:"singleMeasure"
    },
    {
      name:"mainHeaderHeight",
      title:"Main Header Height",
      type:"height",
      controlType:"singleMeasure",
    },
    {
      name:"bodyMargin",
      title:"Body Margin",
      type:"margin",
      controlType:"multiMeasure",
    }

  ]
  constructor() { }

  ngOnInit(): void {
  }

}
